// extracted by mini-css-extract-plugin
export var container = "_pr-0";
export var dotAnimation = "_pr-2";
export var dotsLoading = "_pr-1";